import React from "react";
import { Provider } from "react-redux";
import { DndProvider } from "react-dnd-multi-backend";
import { HTML5toTouch } from "rdndmb-html5-to-touch";
import { Toast } from "@prestosports/commons-ui";

import { BrowserRouter } from "react-router-dom";
import configureStore from "../store/configure-store";

import "./app.css";
import "@prestosports/commons-ui/lib/index.css";

import AppModeSwitcher from "../views/common/components/AppModeSwitcher";
import NewRelicMetrics from "../views/metrics/NewRelicMetrics";

const App = () => {
	const store = configureStore();
	const { ToastProvider } = Toast;

	return (
		<div className="app">
			<a href="#main-content" className="skip-to-content">
				Skip to main content
			</a>
			<BrowserRouter>
				<Provider store={store}>
					<DndProvider options={HTML5toTouch}>
						<ToastProvider />
						<AppModeSwitcher />
						<NewRelicMetrics />
					</DndProvider>
				</Provider>
			</BrowserRouter>
		</div>
	);
};

export default App;
